module.exports = __webpack_public_path__ + "img/x.9411bf26.svg";